import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FiCheckCircle } from 'react-icons/fi';

const SuccessContainer = styled.div`
  background-color: #f8f9fa;
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  max-width: 600px;
  margin: 0 auto;
`;

const IconContainer = styled.div`
  font-size: 4rem;
  color: #28a745;
  margin-bottom: 1rem;
`;

const Title = styled.h2`
  color: var(--dark);
  margin-bottom: 1rem;
`;

const Message = styled.p`
  color: var(--gray);
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

const PrimaryButton = styled(Link)`
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  transition: background-color 0.3s ease, transform 0.2s ease;
  
  &:hover {
    background-color: var(--primary-dark);
    transform: translateY(-2px);
    color: white;
  }
`;

const SecondaryButton = styled(Link)`
  background-color: white;
  color: var(--primary);
  border: 1px solid var(--primary);
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  transition: background-color 0.3s ease, transform 0.2s ease;
  
  &:hover {
    background-color: var(--light);
    transform: translateY(-2px);
    color: var(--primary);
  }
`;

const SuccessMessage = ({ title, message, primaryButtonText, primaryButtonLink, secondaryButtonText, secondaryButtonLink }) => {
  return (
    <SuccessContainer>
      <IconContainer>
        <FiCheckCircle />
      </IconContainer>
      <Title>{title}</Title>
      <Message>{message}</Message>
      <ButtonContainer>
        {primaryButtonText && primaryButtonLink && (
          <PrimaryButton to={primaryButtonLink}>{primaryButtonText}</PrimaryButton>
        )}
        {secondaryButtonText && secondaryButtonLink && (
          <SecondaryButton to={secondaryButtonLink}>{secondaryButtonText}</SecondaryButton>
        )}
      </ButtonContainer>
    </SuccessContainer>
  );
};

export default SuccessMessage;
